import { logout, getUsajConfig, getUserObject } from './sessionmain';
import { getCurrentTime } from '../utilities';

const warnTime = 480000; // 8 min
const heartbeatInterval = 1000;
const keepAliveInterval = 120000; // 2 min
const keyPressThreshold = 10;
const keyPressTimePeriod = 30000; // 30 seconds
let sessionTimerModal: HTMLDialogElement | null;
let sessionStart = 0;
let heartbeatTimer: ReturnType<typeof setInterval>;
let timeOut = 1200000; // default to 20 min
let warnAfter: number;
let gaveWarning = false;
let keyPressCount = 0;
let lastKeyPress = 0;

document.addEventListener('DOMContentLoaded', () => {
    init();
    window.addEventListener('userObjectChanged', init);
});

function init() {
    const userObject = getUserObject();
    if (heartbeatTimer || !userObject?.IsAuthenticated) {
        return;
    }
    initSessionTimer();
    document.addEventListener("keypress", keyPressCheck);
    document.addEventListener("click", (event) => clickCheck(event));
    document.addEventListener("touchend", (event) => clickCheck(event));
    document.addEventListener("touchmove", (event) => clickCheck(event));
}

function clickCheck(event: UIEvent) {
    if (!sessionTimerModal?.contains(event.target as Node)) {
        resetSessionTimer();
    }
}

function keyPressCheck() {
    const diff = getCurrentTime() - lastKeyPress;
    if (keyPressCount >= keyPressThreshold || diff > keyPressTimePeriod) {
        resetSessionTimer();
        keyPressCount = 0;
    } else {
        keyPressCount++;
    }
    lastKeyPress = getCurrentTime();
}

function initLogout() {
    clearInterval(heartbeatTimer);
    logout();
}

function resetSessionTimer(keepAlive: boolean = false) {
    const sessionElapsed = getCurrentTime() - sessionStart;
    if (keepAlive || sessionElapsed > keepAliveInterval) {
        sessionStart = getCurrentTime();
        sendKeepAlive();
    }
}

function sendKeepAlive() {
    fetch("/Account/KeepAlive").catch(error => {
        console.debug('Error sending keep alive request', error);
    });
}

function heartBeat() {
    const sessionElapsed = getCurrentTime() - sessionStart;
    if (sessionElapsed > timeOut) {
        initLogout();
    } else if (sessionElapsed > warnAfter) {
        if (gaveWarning === false) {
            sendKeepAlive();
            gaveWarning = true;
            sessionTimerModal?.showModal();
        }
        const warningTimeLabel = document.querySelector<HTMLElement>('#warnTimeMinutes');
        if (warningTimeLabel !== null) {
            const warnMinutes = (warnAfter > 0) ? Math.ceil((timeOut - sessionElapsed) / 1000 / 60) : 0;
            const warnText = warnMinutes > 1 ? `${warnMinutes.toString()} minutes` : 'less than 1 minute';
            if (warningTimeLabel.innerText !== warnText) {
                warningTimeLabel.innerText = warnText;
            }
        }
    }
}

function initHeartbeat() {
    sessionStart = getCurrentTime();
    heartbeatTimer = setInterval(heartBeat, heartbeatInterval);
}

export function initSessionTimer() {
    const usajConfig = getUsajConfig();
    timeOut = usajConfig.IdleTimeout || timeOut;
    warnAfter = timeOut - warnTime;
    sessionTimerModal = document.querySelector<HTMLDialogElement>('#sessionTimer-modal');
    initHeartbeat();
    if (sessionTimerModal === null) {
        console.debug('Cannot send timeout warning to user: Session timer modal is null.');
        gaveWarning = true;
    } else {
        sessionTimerModal.addEventListener("close", () => {
            gaveWarning = false;
            resetSessionTimer(true);
        });
        document.querySelector<HTMLButtonElement>('#sessionTimer-logout')?.addEventListener('click', initLogout);
    }
}
